<script>
export default [
  { bankCode: 'AFFN', bankName: 'Affin Bank' },
  { bankCode: 'AGRO', bankName: 'AGRO Bank' },
  { bankCode: 'ALRA', bankName: 'Al-Rajhi Banking & Investment Corp' },
  { bankCode: 'ALBB', bankName: 'Alliance Bank' },
  { bankCode: 'AMBB', bankName: 'Ambank' },
  { bankCode: 'BBB', bankName: 'Bangkok Bank Berhad' },
  { bankCode: 'BIS', bankName: 'Bank Islam' },
  { bankCode: 'BRAK', bankName: 'Bank Rakyat' },
  { bankCode: 'BMUA', bankName: 'Bank Muamalat' },
  { bankCode: 'BAME', bankName: 'Bank of America' },
  { bankCode: 'BTOK', bankName: 'Bank of Tokyo-Mitsubishi UFJ' },
  { bankCode: 'BSN', bankName: 'Bank Simpanan Nasional' },
  { bankCode: 'BNPP', bankName: 'BNP Paribas Malaysia Berhad' },
  { bankCode: 'CIMB', bankName: 'CIMB Bank' },
  { bankCode: 'CITI', bankName: 'Citibank' },
  { bankCode: 'DEUT', bankName: 'Deutsche Bank' },
  { bankCode: 'HLBB', bankName: 'Hong Leong Bank' },
  { bankCode: 'HSBC', bankName: 'HSBC Bank' },
  { bankCode: 'BCIN', bankName: 'Industrial and Commercial Bank of China (Malaysia) Berhad' },
  { bankCode: 'JPMC', bankName: 'J.P. Morgan Chase Bank Berhad' },
  { bankCode: 'KUWA', bankName: 'Kuwait Finance House' },
  { bankCode: 'MBB', bankName: 'Maybank' },
  { bankCode: 'MIZU', bankName: 'Mizuho Bank' },
  { bankCode: 'OCBC', bankName: 'OCBC Bank' },
  { bankCode: 'PBB', bankName: 'Public Bank' },
  { bankCode: 'RHB', bankName: 'RHB Bank' },
  { bankCode: 'RBS', bankName: 'RBS Bank' },
  { bankCode: 'STDC', bankName: 'Standard Chartered Bank' },
  { bankCode: 'SMBC', bankName: 'Sumitomo Mitsui Banking Corporation Malaysia Berhad' },
  { bankCode: 'UOB', bankName: 'UOB' },
  { bankCode: 'IIMB', bankName: 'INDIA INTERNATIONAL BANK MALAYSIA BERHAD' }
]

</script>


// WEBPACK FOOTER //
// src/components/Param/ChequeBankCode.vue